module.exports = __webpack_public_path__ + "img/unrevealed5.04f8e508.svg";